module.exports = __webpack_public_path__ + "static/media/insta.ec74d8ae.webp";